import React, { Component } from 'react';
import PropTypes from 'prop-types';
import values from 'lodash/values';
import Promise from 'bluebird';
import {logAmplitudeConclusionLinkClick, logExperienceSocialShare} from "../../amplitude";

// Components
import FullPageLayout from '../../components/FullPageLayout/index';
import {Campaign} from 'dabbl-react-components';

class CampaignPage extends Component {

  static propTypes = {
    // Required - redux
    answers: PropTypes.object.isRequired,
    campaigns: PropTypes.array.isRequired,

    // Redux Actions - Required
    postCampaignCompletionAnswer: PropTypes.func.isRequired,
    finishCampaign: PropTypes.func.isRequired,
    addEngagementAnswer: PropTypes.func.isRequired,
    postEngagementAnswers: PropTypes.func.isRequired,
    // getCardBalance: PropTypes.func.isRequired,
    addToBufferAmt: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    trackCtaClick: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    const {
      campaigns,
      setLoading,
      match,
      history,
    } = props;

    const campaignId = match.params.campaignId;
    const campaign = campaigns.find(c => c.id === campaignId);
    console.debug(campaignId);
    console.debug(campaign);
    const engagementStartIndex = this.findEngIdx(campaign);

    if ( !campaigns || campaigns.length === 0 // no campaigns
      || !campaign // don't have this campaign
      // || !campaign.engagements || campaign.engagements.length === 0    // don't have engagements
      // || engagementStartIndex === -1 // all engagements answered
    ) {
      this.state = { campaign: null, engagementStartIndex: -1 };
      history.push('/app/campaigns');
      return;
    }

    // Hide Page While Loading
    setLoading(true);

    console.log(campaign);
    // Update State
    this.state = {
      campaign: campaign,
      engagementStartIndex: engagementStartIndex
    };
  }

  componentDidMount() {

    console.debug(this.props)
    console.debug("CampaignPage: componentDidMount")
    // Scroll to top of page
    window.scrollTo(0,0);

    window.onpopstate = (e) => {
      e.preventDefault();
      console.debug("Back clicked")
      const engagementStartIndex = this.findEngIdx(this.state.campaign);
      this.onCloseCampaign(engagementStartIndex, 0, false)
      window.onpopstate = () => {}
    }
  }

  componentWillUnmount() {
    console.debug("CampaignPage: componentWillUnmount")
  }

  /*
    Get the current engagement idx by checking for
    previously answered engagements

    return 0 otherwise (to start at first campaign)
  */
  findEngIdx(campaign) {
    const { answers } = this.props;

    if (!campaign) {
      return -1
    }

    if (answers[campaign.id]) {
      // Find last completed engagement by ordinal (i.e. largest ordinal)
      const lastCompletedEngagement = values(answers[campaign.id]) // turn object of objects into array of objects
        .reduce((currEng, nextEng) => {
          return (currEng.engagementOrdinal > nextEng.engagementOrdinal) ? currEng : nextEng;
        });

      const nextOrdinal = lastCompletedEngagement.engagementOrdinal + 1;
      return campaign.engagements.findIndex(e => e.ordinal === nextOrdinal); // index or -1
    }

    // Default to 1st engagement
    return 0;
  }

  handleDoneCampaign() {
    if (this.state.campaign.campaignComplete) {
      return Promise.resolve()
        .then(() => this.props.history.push('/app/campaigns'))
    }
    const campaignId = this.state.campaign.id
    const { finishCampaign } = this.props;
    return Promise.resolve()
      .then(() => finishCampaign(campaignId))
      .catch((err) => {
        console.log('CampaignPage - error handling done campaign.');
        console.log(err);
      });
  }

  onSkipShareCampaign() {
    const {
      history,
      setLoading,
    } = this.props;
    return Promise.resolve()
      .then(() => setLoading(true))
      .then(() => history.push('/app/campaigns'))
      .catch((err) => {
        console.log('CampaignPage - error handling handleSkipShareCampaign.');
        console.log(err);
      });
  }

  handleAllEngagementsAnswered(campaignId) {
    return Promise.resolve()
      .then(() => this.props.postEngagementAnswers(campaignId))
      .then(() => this.props.addToBufferAmt(campaignId))
      .then(() => this.props.finishCampaign(campaignId))
      .catch((err) => {
        console.log('CampaignPage - error handling conclusion rating.');
        console.log(err);
      });
  }


  handleEngagementAnswered(engagementIndex, answer, duration){
    console.log(`Campaign: handleEngagementAnswered, index = ${engagementIndex}, answer = ${answer}, duration =${duration}`)
    const { campaign } = this.state;
    const engagement = campaign.engagements[engagementIndex];
    return this.props.addEngagementAnswer({
      answer: answer,
      campaignId: campaign.id,
      engagementId: engagement.id,
      engagementOrdinal: engagement.ordinal,
      duration: duration
    })
  }

  onCloseCampaign(engagementIndex, stepDuration, isCompleted){
    const { history, setLoading } = this.props;
    const campaignId = this.state.campaign.id
    console.log("Campaign: onCloseCampaign with engagementIndex = " + engagementIndex + " and stepDuration " + stepDuration)
    if (isCompleted) {
      return Promise.resolve()
        .then(() => setLoading(true))
    } else if (engagementIndex > 0) {
      return Promise.resolve()
        .then(() => setLoading(true))
        .then(() => {this.props.postEngagementAnswers(campaignId)}) // send partially answered campaign to backend
        .then(() => history.push('/app/campaigns'))
    }
    return Promise.resolve()
      .then(() => history.push('/app/campaigns'))
  }

  onCampaignAssetsCached() {
    this.props.setLoading(false);
  }

  handleShareCampaign(network){
    const { campaign } = this.state;
    console.log(`Campaign share for ${network} was clicked`)
    logExperienceSocialShare(campaign.name, campaign.id, campaign.previewDL, network)
  }

  render() {
    const { campaign, engagementStartIndex } = this.state;
    const { trackCtaClick } = this.props;
    if (!campaign)
      return <div>Experience not found</div>
    return (
      <span>
        <div className="campaign-page">
          <FullPageLayout className="vertical-center">
              <Campaign
                // Engagements
                campaign={campaign}
                retailerName="ShopRite"
                engagementStartIndex={engagementStartIndex}
                onEngagementAnswered={(engagementIndex, answer, duration) => this.handleEngagementAnswered(engagementIndex, answer, duration) }
                onAllEngagementsAnswered = {() => this.handleAllEngagementsAnswered(campaign.id)}
                onDoneCampaign = { () => this.handleDoneCampaign() } // occurred only if revisiting completed campaign
                onShareButtonClick = { (network) => this.handleShareCampaign(network) }
                onSkipShareCampaign = { () => this.onSkipShareCampaign() }
                onCloseCampaign = { (engagementIndex, stepDuration, isCompleted) => { this.onCloseCampaign(engagementIndex, stepDuration, isCompleted) }}
                onCampaignAssetsCached = { (success) => {this.onCampaignAssetsCached(success)} }
                onConclusionLinkClick = {(url) => { logAmplitudeConclusionLinkClick(campaign.id, campaign.name, campaign.brandName, url); trackCtaClick(campaign.id);} }
              />
            {/* Flex Spacer Div */}
            <div style={{height: '1px'}}></div>
            <div style={{height: '1px'}}></div>
            <div style={{height: '1px'}}></div>
          </FullPageLayout>
        </div>
      </span>
    );
  }
}

export default CampaignPage;



// WEBPACK FOOTER //
// ./src/pages/CampaignPage/CampaignPage.js